import { render } from "./Lessons.vue?vue&type=template&id=5e8bd71e&scoped=true"
import script from "./Lessons.vue?vue&type=script&lang=js"
export * from "./Lessons.vue?vue&type=script&lang=js"

import "./Lessons.vue?vue&type=style&index=0&id=5e8bd71e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e8bd71e"]])

export default __exports__